export const CompensationStatus = {
    Open: 0,
    Closed: 1,
    ApprovalRequested: 2
};

export const CompensationStatusTranslation = {
    [CompensationStatus.Open]: "compensationstatus.open",
    [CompensationStatus.Closed]: "compensationstatus.closed",
    [CompensationStatus.ApprovalRequested]: "compensationstatus.approvalrequested"
}